import script from "./returnRefund.vue?vue&type=script&setup=true&lang=js"
export * from "./returnRefund.vue?vue&type=script&setup=true&lang=js"

import "./returnRefund.vue?vue&type=style&index=0&id=0d9597c1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9597c1"]])

export default __exports__